import React from 'react';
import { Link } from 'react-router-dom';
import { FaApple } from 'react-icons/fa';
import AppIcon from './AppIcon';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <AppIcon size={40} />
            <div>
              <h3>Nurturing Inner Love</h3>
              <p>Mindfulness & Self-Awareness Platform</p>
            </div>
          </div>
          
          <div className="footer-links">
            <div className="footer-section">
              <h4>Platform</h4>
              <Link to="/chapters">Chapters</Link>
              <a href="https://apps.apple.com/us/app/esscape/id6749832973" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <FaApple /> App Store
              </a>
            </div>
            
            <div className="footer-section">
              <h4>Support</h4>
              <Link to="/help">Help Center</Link>
              <Link to="/contact">Contact Us</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
            
            <div className="footer-section">
              <h4>Connect</h4>
              <a href="#newsletter">Newsletter</a>
              <a href="#community">Community</a>
              <a href="#social">Follow Us</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2026 Nurturing Inner Love. All rights reserved.</p>
          <p>Made with 💚 for mindfulness and self-discovery</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
